/**
 * Curated images for Popular Cities cards (must match server/config/cityCardImages.js).
 */
export const CITY_CARD_IMAGES = {
  bengaluru:
    'https://images.unsplash.com/photo-1596176530529-78163a4fbfaf?auto=format&fit=crop&w=800&q=80',
  bangalore:
    'https://images.unsplash.com/photo-1596176530529-78163a4fbfaf?auto=format&fit=crop&w=800&q=80',
  mysuru:
    'https://images.unsplash.com/photo-1587474260584-136574528ed5?auto=format&fit=crop&w=800&q=80',
  mysore:
    'https://images.unsplash.com/photo-1587474260584-136574528ed5?auto=format&fit=crop&w=800&q=80',
  mangaluru:
    'https://images.unsplash.com/photo-1559827260-dc66d52bef19?auto=format&fit=crop&w=800&q=80',
  mangalore:
    'https://images.unsplash.com/photo-1559827260-dc66d52bef19?auto=format&fit=crop&w=800&q=80',
  chikkamagaluru:
    'https://images.unsplash.com/photo-1447933601403-0c6688de566e?auto=format&fit=crop&w=800&q=80',
  chikmagalur:
    'https://images.unsplash.com/photo-1447933601403-0c6688de566e?auto=format&fit=crop&w=800&q=80',
  chikmangalur:
    'https://images.unsplash.com/photo-1447933601403-0c6688de566e?auto=format&fit=crop&w=800&q=80',
  hubballi:
    'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=800&q=80',
  hubli:
    'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=800&q=80',
  kalaburagi:
    'https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=800&q=80',
  gulbarga:
    'https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=800&q=80',
  shivamogga:
    'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80',
  shimoga:
    'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80',
  udupi:
    'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=800&q=80',
  kadaba:
    'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?auto=format&fit=crop&w=800&q=80',
  madikeri:
    'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=800&q=80',
  coorg:
    'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=800&q=80',
  kodagu:
    'https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=800&q=80',
  belagavi:
    'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?auto=format&fit=crop&w=800&q=80',
  belgaum:
    'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?auto=format&fit=crop&w=800&q=80',
  davanagere:
    'https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?auto=format&fit=crop&w=800&q=80',
  ballari:
    'https://images.unsplash.com/photo-1539650116574-75c0c6d73bb6?auto=format&fit=crop&w=800&q=80',
  bellary:
    'https://images.unsplash.com/photo-1539650116574-75c0c6d73bb6?auto=format&fit=crop&w=800&q=80',
  goa:
    'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?auto=format&fit=crop&w=800&q=80',
  panaji:
    'https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?auto=format&fit=crop&w=800&q=80',
  mumbai:
    'https://images.unsplash.com/photo-1567335882562-bc07faebb92d?auto=format&fit=crop&w=800&q=80',
  'new delhi':
    'https://images.unsplash.com/photo-1583394838332-acf977043cfc?auto=format&fit=crop&w=800&q=80',
  delhi:
    'https://images.unsplash.com/photo-1583394838332-acf977043cfc?auto=format&fit=crop&w=800&q=80',
  hyderabad:
    'https://images.unsplash.com/photo-1578662996442-48f60103fc96?auto=format&fit=crop&w=800&q=80',
  chennai:
    'https://images.unsplash.com/photo-1583417319070-4a5ecad78186?auto=format&fit=crop&w=800&q=80',
  pune:
    'https://images.unsplash.com/photo-1590069261209-1e9a36d31966?auto=format&fit=crop&w=800&q=80',
  kolkata:
    'https://images.unsplash.com/photo-1558431382-27e303142255?auto=format&fit=crop&w=800&q=80',
  jaipur:
    'https://images.unsplash.com/photo-1477587459743-66d8e0e2e7e5?auto=format&fit=crop&w=800&q=80',
  dubai:
    'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=800&q=80',
  kochi:
    'https://images.unsplash.com/photo-1609940711956-c4ad5fb88866?auto=format&fit=crop&w=800&q=80',
  cochin:
    'https://images.unsplash.com/photo-1609940711956-c4ad5fb88866?auto=format&fit=crop&w=800&q=80',
  udaipur:
    'https://images.unsplash.com/photo-1524492412937-b5c8e2f40d0c?auto=format&fit=crop&w=800&q=80',
};

/** Rotating fallbacks so unknown cities do not all share one image. */
export const FALLBACK_CITY_CARD_IMAGES = [
  'https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1566073771259-52a2b9aca9bd?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=800&q=80',
];

export const DEFAULT_CITY_CARD_IMAGE = FALLBACK_CITY_CARD_IMAGES[0];

export const normalizeCityKey = (name) =>
  String(name || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');

const hashCityKey = (key) => {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash << 5) - hash + key.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const findPartialCityImage = (key) => {
  if (!key) return null;
  const entries = Object.entries(CITY_CARD_IMAGES);
  const exactPartial = entries.find(([cityKey]) => key.includes(cityKey) || cityKey.includes(key));
  return exactPartial ? exactPartial[1] : null;
};

export const getCityCardImage = (cityName) => {
  const key = normalizeCityKey(cityName);
  if (!key) return DEFAULT_CITY_CARD_IMAGE;

  if (CITY_CARD_IMAGES[key]) {
    return CITY_CARD_IMAGES[key];
  }

  const partial = findPartialCityImage(key);
  if (partial) {
    return partial;
  }

  const fallbackIndex = hashCityKey(key) % FALLBACK_CITY_CARD_IMAGES.length;
  return FALLBACK_CITY_CARD_IMAGES[fallbackIndex];
};

export const enrichPopularCity = (city) => ({
  ...city,
  name: String(city?.name || '')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase()),
  image: getCityCardImage(city?.name),
});
